import { render, staticRenderFns } from "./Applicants.vue?vue&type=template&id=6dff97b4&lang=pug&"
import script from "./Applicants.vue?vue&type=script&lang=js&"
export * from "./Applicants.vue?vue&type=script&lang=js&"
import style0 from "./Applicants.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports